/** Answer sent when the applicant runs out of time or skips through the help menu. */
export const NO_ANSWER = -1;

/** Exam discriminator the proctoring endpoint expects. */
export const PROCTORING_TYPE = 'multipleChoiceExam';

/** `pre` selects what the exam endpoint returns: `'0'` the summary, `'n'` question n. */
export const EXAM_SUMMARY = '0';

/** The exam endpoint answers `208` when every question has already been answered. */
export const ALREADY_ANSWERED = 208;

export const ERROR_MESSAGE = 'An error occured, please try again.';
